import { useNavigate } from '@tanstack/react-router'
import { Skeleton } from '@shared/design-system/ui'
import { useMemberProductQuery } from '../api/member-access.queries'
import { useMemberSession } from '../model/member-session-store'
import { MemberAccessLayout } from './MemberAccessLayout'

export function MemberCoursePage({ producerId, productId }: { producerId: string; productId: string }) {
  const navigate = useNavigate()
  const token = useMemberSession((state) => state.token)
  const product = useMemberProductQuery(productId, Boolean(token))

  if (!token) {
    void navigate({ to: '/acesso/$producerId', params: { producerId } })
    return null
  }
  if (product.data?.kind === 'files') {
    void navigate({ to: '/acesso/$producerId/arquivos/$productId', params: { producerId, productId } })
    return null
  }
  if (product.isError) {
    void navigate({
      to: '/acesso/$producerId/cursos/$productId/oferta',
      params: { producerId, productId },
    })
    return null
  }
  const course = product.data?.kind === 'course' ? product.data.course : undefined
  const lessonId = course?.product.continueLessonId ?? course?.modules.flatMap((module) => module.lessons)[0]?.id
  if (lessonId) {
    void navigate({
      to: '/acesso/$producerId/cursos/$productId/aulas/$lessonId',
      params: { producerId, productId, lessonId },
    })
    return null
  }
  return (
    <MemberAccessLayout producerName={course?.producerName ?? 'Area de membros'} logoUrl={course?.logoUrl}>
      <Skeleton height={280} radius="16px" />
    </MemberAccessLayout>
  )
}
